

const OrderConfirmationModal = ({ isOpen, onClose, cartItems, total }) => {
  if (!isOpen) return null;

  const formatWhatsAppMessage = () => {
    let message = "🛒 *ORDER FROM EGGCELLENT E-COMMERCE* 🛒\n\n";
    message += "================================\n\n";
    
    cartItems.forEach((item) => {
      const itemTotal = (item.price * item.quantity).toFixed(2);
      message += `*${item.name}*\n`;
      message += `Quantity: ${item.quantity}\n`;
      message += `Price: ₹${item.price.toFixed(2)} each\n`;
      message += `Total: ₹${itemTotal}\n\n`;
    });
    
    message += "================================\n";
    message += `*ORDER TOTAL: ₹${total.toFixed(2)}*\n\n`;
    message += "Please provide:\n";
    message += "1. Shipping address\n";
    message += "2. Preferred delivery time\n";
    message += "3. Payment method (Cash on Delivery/Bank Transfer)\n\n";
    message += "Thank you! 🥚";
    
    return encodeURIComponent(message);
  };

  const handleWhatsAppRedirect = () => {
    if (cartItems.length === 0) {
      alert("Your cart is empty!");
      return;
    }
    
    
    const phoneNumber = "918369918068";
    
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${formatWhatsAppMessage()}`;
    
    window.open(whatsappURL, '_blank');
    onClose();
  };

  return (
    <div className="order-confirmation-modal">
      <div className="modal-content">
        <button className="close-modal" onClick={onClose}>
          <i className="fas fa-times"></i>
        </button>
        
        <i className="fas fa-check-circle success-icon" style={{ fontSize: '3rem', color: '#25D366', marginBottom: '1rem' }}></i>
        
        <h3>Confirm Your Order</h3>
        
        <div className="order-details">
          <h4>Order Summary</h4>
          {cartItems.map(item => (
            <div key={item.id} className="order-item">
              <span>{item.quantity} × {item.name}</span>
              <span>₹{(item.price * item.quantity).toFixed(2)}</span>
            </div>
          ))}
          <div className="order-total" style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '2px solid #ddd', fontWeight: 'bold' }}>
            <span>Total Amount:</span>
            <span>₹{total.toFixed(2)}</span>
          </div>
        </div>
        
        <p>You'll be redirected to WhatsApp to complete your order. Please send the pre-filled message to confirm.</p>
        
        <div className="modal-buttons">
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="confirm-btn" onClick={handleWhatsAppRedirect}>
            <i className="fab fa-whatsapp"></i> Send via WhatsApp
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmationModal;